// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.theme--dark.v-stepper .v-stepper__step__step {\n    color: black !important;\n}\n.v-stepper__content {\n    background-color: #1e1e1e !important;\n}\n.v-stepper__header {\n    background-color: #1e1e1e !important;\n}\n.w-crypto-border {\n    border-left: 4px rgba(50, 50, 50, 90%) solid !important;\n    border-bottom: 2px rgba(50, 50, 50) solid !important;\n    background: rgba(50, 50, 50, 0%) !important;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
